/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { DatePicker } from "@progress/kendo-react-dateinputs";

export default function FormHookDatePicker({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  errors,
  control,
  datePickerProps,
  onDateChange,
}) {
  return (
    <FormControl isRequired={Boolean(isRequired)}>
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <DatePicker
              {...datePickerProps}
              className={errors[name] ? "error-field" : ""}
              disabled={disabled}
              value={field.value || null}
              onChange={(e) => {
                if (onDateChange) {
                  onDateChange(e);
                }
                field.onChange(e.value);
              }}
            />
          );
        }}
      />
      {info ? (
        <p className="error-message" style={{ color: "black" }}>
          {info || ""}
        </p>
      ) : (
        <></>
      )}
      {errors ? (
        errors[name] ? (
          <p className="error-message">
            {errors[name].message || "Please Select Date!"}
          </p>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </FormControl>
  );
}
